// extracted by mini-css-extract-plugin
export var container = "_6i-0";
export var containerTopRight = "_6i-1";